import { useCallback, useState } from "react";
import { getDuplicateBillsData, getUtilityBills, UtilityBillsDTO } from "api";
import { useNotify } from "hooks";

import { FetchBillsHookOptions, FetchBillsHookResult, FetchBillsRequest } from "./types";

export const useFetchBillsData = ({
  queryObject,
  updateFromApiResponse,
}: FetchBillsHookOptions): FetchBillsHookResult => {
  const notify = useNotify();

  const [loading, setLoading] = useState<boolean>(false);
  const [loadingBills, setLoadingBills] = useState<boolean>(false);
  const [utilityBillsData, setUtilityBillsData] = useState<UtilityBillsDTO | null>(null);
  const [duplicateData, setDuplicateData] = useState<any[]>([]);

  const fetchBillsData = useCallback(async ({
    billType,
    queryOverrides,
  }: FetchBillsRequest) => {
    const requestBody = { ...queryObject, ...queryOverrides };

    try {
      setLoading(true);
      setLoadingBills(true);

      if (billType === 'duplicate') {
        const res = await getDuplicateBillsData(requestBody);
        const { bills, pageResult } = res;
        setDuplicateData(bills || []);
        if (pageResult) {
          updateFromApiResponse(pageResult);
        }
      } else {
        const response = await getUtilityBills(requestBody);
        setUtilityBillsData(response);
        if (response?.pageResult) {
          updateFromApiResponse(response.pageResult);
        }
      }
    } catch (error: any) {
      const errorMessage = billType === 'duplicate'
        ? "Something went wrong while fetching duplicate bills data!"
        : typeof error.response?.data === "string"
          ? error.response?.data
          : "Failed to load Utility Bills Data.";
      notify.error(errorMessage);
    } finally {
      setLoading(false);
      setLoadingBills(false);
    }
  }, [queryObject, notify, updateFromApiResponse]);

  return {
    fetchBillsData,
    loading,
    loadingBills,
    utilityBillsData,
    duplicateData,
  };
};
